module.exports = __webpack_public_path__ + "img/shiftReport.a042b9d3.svg";